import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { sign, getSignaturePreferences, setPreferencesDialogVisibility, getSignatures } from '../../reducers/signatures';
import { dateToFloatingString } from '../../utilities/dateTime';

import './signature.css';

class Signature extends React.Component {
    constructor(props) {
        super(props);

        this.renderSignature = this.renderSignature.bind(this);
    }

    renderSignature(signature) {
        const { preferences } = this.props;
        let font = preferences.esig_font;
        let name = preferences.esig_name;
        let date = signature.created_at;

        return (
            <div className="signature-content">
                <div>
                    <div className={`signature-name signature-font-${font} no-select`}>{name}</div>
                    {date && <div className="signature-date">{dateToFloatingString(date)}</div>}
                </div>
            </div>
        );
    }

    componentDidMount() {
        const { role, profile, signatureList, preferences, getSignatures, getSignaturePreferences } = this.props;
        if (!preferences) {
            getSignaturePreferences(profile.id);
        }

        if (!signatureList) {
            getSignatures(role);
        }
    }

    render() {
        const { name, preferences, signatureList } = this.props;
        if (!preferences || !signatureList) {
            return null;
        }

        let signature = signatureList.find(s => s.name === name);
        let isSigned = signature !== undefined;

        return isSigned ? this.renderSignature(signature) : null;
    }
}

Signature.defaultProps = {
    name: undefined,
    onSigned: undefined
};
Signature.propTypes = {
    name: PropTypes.string.isRequired,
    onSigned: PropTypes.func
};

const mapStateToProps = state => ({
    role: state.identity.role,
    profile: state.identity.profile,
    signatureList: state.signatures.list,
    preferences: state.signatures.preferences,
    dialogVisible: state.signatures.dialogVisible === true
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            sign: sign,
            getSignatures: getSignatures,
            getSignaturePreferences: getSignaturePreferences,
            setPreferencesDialogVisibility: setPreferencesDialogVisibility
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Signature);



// WEBPACK FOOTER //
// ./src/components/signature/index.jsx